import { Reorder } from '@rio-cloud/rio-uikit/motion';
import noop from 'lodash/fp/noop';
import React, { type FunctionComponent } from 'react';
import { batch, type ConnectedProps, connect } from 'react-redux';

import { routesActions } from '../../application/redux/routes/routesReducer';
import { searchActions, type Waypoint } from '../../application/redux/search/searchReducer';
import { getOrderedWaypoints } from '../../application/redux/search/searchSelectors';
import type { AppDispatch, RootState } from '../../configuration/setup/store';
import { clearRoute } from '../livemonitorCommunication/propagateRoutesToParent';
import { WaypointListItemContainer } from './WaypointListItem';
import { WaypointsOptionsContainer } from './WaypointsOptions';

export const SearchEditor: FunctionComponent<SearchEditorProps> = React.memo(props => {
    const { waypoints = [], waypointOrderChanged = noop } = props;

    return (
        <div className={'RoutePlannerSearch'} data-testid={'RoutePlannerSearch'}>
            <Reorder.Group
                as='div'
                axis='y'
                values={waypoints}
                onReorder={waypointOrderChanged}
                className='bg-lightest'
            >
                {waypoints.map((waypoint, index) => (
                    <WaypointListItemContainer
                        key={`item-${waypoint.id}`}
                        orderIndex={index}
                        value={waypoint}
                        allowRemove={waypoints.length > 2}
                        totalWaypoints={waypoints.length - 1}
                    />
                ))}
            </Reorder.Group>
            <WaypointsOptionsContainer />
        </div>
    );
});

type SearchEditorProps = ConnectedProps<typeof connector>;

export const mapStateToProps = (state: RootState) => ({
    waypoints: getOrderedWaypoints(state),
});

export const mapDispatchToProps = (dispatch: AppDispatch) => ({
    waypointOrderChanged: (waypoints: Waypoint[]) => {
        batch(() => {
            dispatch(searchActions.waypointsOrderChanged(waypoints));
            dispatch(routesActions.suggestedRoutesRemoved());
            clearRoute();
        });
    },
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export const SearchEditorContainer = connector(SearchEditor);
export default SearchEditorContainer;
